import React from 'react';

const Footer = () => (
	<footer className="footer">
		<div className="content has-text-centered">
			<p><strong>Transporte por Aplicativo</strong> © <a href="http://www.indaiatuba.sp.gov.br">Prefeitura Municipal de Indaiatuba</a>.</p>
			<p>Av. Eng. Fábio Roberto Barnabé, 2800 - M.D. - CEP: 13331-900 - Telefones: (19) 3834-9000 / (19) 3894-2049 / 0800-770-7702</p>
			<p>Desenvolvimento: Departamento de Gestão de Tecnologia da Informação.</p>
			<p>Apoio: Departamento de Transportes.</p>
			<p>Secretaria Municipal de Administração.</p>
		</div>
	</footer>
);

export default Footer;